import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  operations as reportOperations,
  selectors as reportSelectors,
} from '../../../../redux/reports'
import LicenseHeader from './component'

export class LicenseHeaderContainer extends Component {
  static propTypes = {
    deleteReports: PropTypes.func.isRequired,
    fetchLessonProgressReport: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    lessonReportData: PropTypes.array,
    license: PropTypes.object.isRequired,
    toggleEditModal: PropTypes.func.isRequired,
  }
  render() {
    const {
      deleteReports,
      fetchLessonProgressReport,
      fetchTrainingReport,
      isFetching,
      reportData,
      license,
      toggleEditModal,
      skuCode
    } = this.props

    return (
      <LicenseHeader
        deleteReports={deleteReports}
        fetchLessonProgressReport={fetchLessonProgressReport}
        fetchTrainingReport={fetchTrainingReport}
        isFetching={isFetching}
        reportData={reportData}
        license={license}
        toggleEditModal={toggleEditModal}
        skuCode={skuCode}
      />
    )
  }
}

const mapStateToProps = ({ reportsManager }, { license }) => {
  const { product } = license || {}
  let { skuCode } = product || {}
  skuCode =
      skuCode === 'MSP' || skuCode === 'K5P' || skuCode === 'K8PF'
      ? 'K8P'
      : skuCode ? skuCode.toUpperCase() : ''
  return {
    skuCode,
    reportData: reportsManager.reports[skuCode] || null,
    isFetching: reportsManager.isFetching[skuCode],
  }
}

const mapDispatchToProps = {
  fetchLessonProgressReport: reportOperations.fetchLessonProgressReport,
  fetchTrainingReport: reportOperations.fetchTrainingReport,
  deleteReports: reportOperations.deleteReports,
  deleteLessonProgressReport: reportOperations.deleteLessonProgressReport,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LicenseHeaderContainer)



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/LicenseHeader/container.js